import { render } from "./testimonials_slider.vue?vue&type=template&id=1cd4ecbb"
import script from "./testimonials_slider.vue?vue&type=script&lang=js"
export * from "./testimonials_slider.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/testimonials_slider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cd4ecbb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cd4ecbb', __exports__)) {
    api.reload('1cd4ecbb', __exports__)
  }
  
  module.hot.accept("./testimonials_slider.vue?vue&type=template&id=1cd4ecbb", () => {
    api.rerender('1cd4ecbb', render)
  })

}


export default __exports__